<div class="min-h-screen flex flex-col">
  <app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>
  <!-- Gradient section – takes all remaining vertical space -->
  <div class="flex-1 bg-gradient-to-br from-red-50 via-orange-100 to-amber-100 flex items-center justify-center p-4 md:p-6">
    <div class="max-w-2xl w-full mx-auto">

      <!-- Main error card (same as before) -->
      <div class="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/40 overflow-hidden transition-all duration-300 transform hover:scale-[1.02]">
        <!-- Decorative top bar -->
        <div class="h-2 bg-gradient-to-r from-red-500 via-orange-500 to-amber-500"></div>

        <div class="p-6 sm:p-8 md:p-10 text-center">
          <!-- Animated error/warning icon -->
          <div class="flex justify-center mb-6">
            <div class="w-24 h-24 bg-gradient-to-br from-red-500 to-orange-600 rounded-full flex items-center justify-center shadow-lg animate-pulse">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>

          <!-- Error heading -->
          <h1 class="text-1xl sm:text-3xl md:text-3xl font-extrabold bg-gradient-to-r from-red-700 to-orange-700 bg-clip-text text-transparent mb-4">
            Sorry! Your Transaction Failed
          </h1>

          <!-- Helpful message -->
          <p class="text-gray-600 text-base sm:text-lg mb-6 max-w-md mx-auto">
            Something went wrong while processing your payment. Please check your payment details or try again.
          </p>

          <!-- Action buttons -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button (click)="download()" class="group relative inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-gray-700 bg-gray-100 rounded-xl shadow-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-all duration-200 transform hover:scale-105 active:scale-95">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Payment History
            </button>

            <button (click)="go()" class="group relative inline-flex items-center justify-center px-8 py-3 text-base font-semibold text-white bg-gradient-to-r from-red-600 to-orange-600 rounded-xl shadow-lg hover:from-red-700 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105 active:scale-95">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Try Again
            </button>
          </div>
        </div>
      </div>

      <!-- Trust & security badges -->
      <div class="mt-6 text-center text-white/70 text-xs flex justify-center gap-4">
        <span class="inline-flex items-center gap-1"><span class="w-1.5 h-1.5 bg-red-300 rounded-full"></span> Secure Payment</span>
        <span class="inline-flex items-center gap-1"><span class="w-1.5 h-1.5 bg-orange-300 rounded-full"></span> 24/7 Support</span>
        <span class="inline-flex items-center gap-1"><span class="w-1.5 h-1.5 bg-amber-300 rounded-full"></span> Money Back Guarantee</span>
      </div>
    </div>
  </div>
</div>